import { App, defineAsyncComponent } from 'vue'

import LoginForm from '@/modules/auth/components/LoginForm.vue'
import SignUp from '@m/auth/components/SignUp.vue'
import SignUpRole from '@m/auth/components/SignUpRole.vue'
const PartnerAddRole = defineAsyncComponent(() => import('@m/auth/components/PartnerAddRole.vue'))
const SetNewPassword = defineAsyncComponent(() => import('@m/auth/components/SetNewPassword.vue'))
const PasswordReset = defineAsyncComponent(() => import('@m/auth/components/PasswordReset.vue'))
const AuthProvider = defineAsyncComponent(() => import('@m/auth/components/AuthProvider.vue'))
const UserAccessState = defineAsyncComponent(() => import('@m/auth/components/UserAccessState.vue'))
const SocialDataComplete = defineAsyncComponent(() => import('@m/auth/components/SocialDataComplete.vue'))
const AgreementCheckbox = defineAsyncComponent(() => import('@m/auth/components/AgreementCheckbox.vue'))
const AuthForbidden = defineAsyncComponent(() => import('@m/auth/components/Forbidden.vue'))
const CoordinatorFillProfile = defineAsyncComponent(() => import('@m/auth/components/CoordinatorFillProfile.vue'))

export default {
  install(app: App<Element>): void {
    app
      .component('LoginForm', LoginForm)
      .component('SignUp', SignUp)
      .component('SignUpRole', SignUpRole)
      .component('PartnerAddRole', PartnerAddRole)
      .component('SetNewPassword', SetNewPassword)
      .component('PasswordReset', PasswordReset)
      .component('AuthProvider', AuthProvider)
      .component('UserAccessState', UserAccessState)
      .component('SocialDataComplete', SocialDataComplete)
      .component('AgreementCheckbox', AgreementCheckbox)
      .component('AuthForbidden', AuthForbidden)
      .component('CoordinatorFillProfile', CoordinatorFillProfile)
  }
}
